/**
 * UpgradeCTA - Reusable upgrade call-to-action for social tier gating
 * Phase 4B - Social Tier Gating
 *
 * Variants:
 * - 'inline': Small text-only CTA for buttons/tooltips
 * - 'banner': Full-width banner with icon for panels/modals
 */

import { Crown } from 'lucide-react';
import { Link } from 'react-router-dom';

interface UpgradeCTAProps {
  variant?: 'inline' | 'banner';
  feature?: string;
  className?: string;
  /** Called when user clicks "View Plans" — use to close parent modals */
  onNavigate?: () => void;
}

export function UpgradeCTA({
  variant = 'banner',
  feature = 'social features',
  className = '',
  onNavigate,
}: UpgradeCTAProps) {
  if (variant === 'inline') {
    return (
      <span className={`text-xs text-amber-400 ${className}`}>
        Upgrade to use {feature}
      </span>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center text-center px-6 py-8 ${className}`}>
      <div className="w-12 h-12 mb-4 bg-amber-500/10 rounded-full flex items-center justify-center">
        <Crown size={24} className="text-amber-400" />
      </div>
      <h3 className="text-lg font-semibold text-white mb-2">Upgrade to Social</h3>
      <p className="text-sm text-slate-400 max-w-xs mb-4">
        {feature} requires a Social or Pro membership.
      </p>
      <Link
        to="/pricing"
        onClick={onNavigate}
        className="px-4 py-2 text-sm font-medium text-white bg-teal-500 rounded-lg hover:bg-teal-600 transition-colors"
      >
        View Plans
      </Link>
    </div>
  );
}
